module.exports = __webpack_public_path__ + "img/3-4.890d4138.svg";